import React from 'react';

interface GroupIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const GroupIcon: React.FC<GroupIconProps> = ({
  width = 29,
  height = 32,
  color = 'currentColor',
  className,
  style,
  title,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 29 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role="img"
    aria-hidden={title ? undefined : true}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M21.8868 11.0276C20.9459 13.3034 19.808 15.426 18.3747 17.6361C15.7707 21.6953 13.0792 24.8682 9.37015 27.6801C8.7465 28.1615 8.62612 29.737 8.89965 30.2184C9.17318 30.6889 9.26073 30.5466 9.87343 30.1199C16.635 24.5181 22.3463 16.6295 24.5564 9.57251C23.6264 9.96639 22.7402 10.4587 21.8868 11.0058V11.0276Z"
      fill={color}
    />
    <path
      d="M27.4009 4.48499C23.7794 5.19616 20.6502 7.26401 17.8712 9.58353C16.427 10.7871 14.9827 12.0344 13.6589 13.3692C13.0571 13.9709 12.4663 14.5946 11.9411 15.262C11.4706 13.0409 10.6063 10.8637 9.18393 9.13497C7.95853 7.64698 5.48584 11.0606 6.52525 12.3298C8.17736 14.332 9.03076 17.0454 9.24958 19.5947C9.34805 20.7763 10.3765 20.9405 11.2081 20.2183C12.4116 19.1789 13.1884 17.7675 14.2387 16.5968C15.3876 15.3167 16.7443 14.2226 18.0353 13.0957C20.5627 10.9074 23.3089 8.93807 26.6679 8.2816C27.6526 8.08466 28.3637 6.89206 28.5278 6.00582C28.681 5.20712 28.3638 4.28805 27.39 4.48499H27.4009Z"
      fill={color}
    />
    <path
      d="M24.4032 3.50022C23.0903 2.95317 22.4229 2.83283 21.8212 2.70154C21.2194 2.57025 20.355 3.00791 19.7861 3.74096C17.9042 6.15895 16.1974 5.51341 15.5956 1.9466C15.3987 0.754017 13.3746 0.163185 11.8975 0.0209501C10.88 -0.07752 10.2454 0.152244 10.1907 1.11506C10.0376 3.65341 9.65461 5.76506 9.02002 7.62505C9.10755 7.67976 9.19507 7.7454 9.2826 7.83293C9.75306 8.33623 10.1688 8.88327 10.5408 9.46315C11.2082 7.49375 11.5474 5.40401 11.7991 3.11731C11.9523 1.71684 13.9217 2.52652 13.9873 3.21581C14.0529 3.86134 14.1405 4.49591 14.3921 5.05391C15.6285 7.95331 19.0421 7.67977 20.9349 5.25084C21.5585 4.45214 23.0794 4.88977 23.4186 5.85259C24.0969 5.52436 24.7971 5.23992 25.5192 4.99922C25.5411 4.43028 25.3879 3.90504 24.4251 3.50022H24.4032Z"
      fill={color}
    />
    <path
      d="M6.57972 27.6692C6.37184 27.4395 6.52502 27.1441 6.72196 26.8815C8.65854 24.2338 7.00644 20.9842 5.02609 21.0499C4.50092 21.0608 4.2274 21.1921 3.86634 21.3452C2.78317 21.8048 1.54679 19.4196 2.36737 18.9273C4.46807 17.6581 6.07644 16.3451 7.31279 14.9884C6.97361 14.2663 6.55784 13.588 6.07643 12.9644C5.51844 13.6536 4.92761 14.332 4.2602 14.9884C2.94727 16.2795 2.11574 16.9688 0.945042 17.6581C-0.488246 18.5115 0.0259959 20.273 0.441759 21.017C0.857522 21.761 1.2514 22.319 1.53587 22.7457C1.95163 23.3803 2.78316 24.2337 3.17704 23.8617C3.64751 23.4241 4.4681 22.9755 4.96045 22.9864C5.91233 22.9864 6.27339 24.0368 5.9561 25.109C5.7701 25.7107 5.14643 26.4329 4.66502 26.8487C4.29302 27.1659 4.33678 27.538 4.5556 27.9647C4.5556 27.9647 6.26242 30.7218 7.46595 31.422C8.26465 31.8925 8.40688 29.3213 7.7723 28.6758C7.22524 28.1287 6.9955 28.1069 6.60162 27.6692H6.57972Z"
      fill={color}
    />
  </svg>
);

export default GroupIcon;
